import { httpMethod } from '../types/http-method.type';
import { httpResponseType } from '../types/http-response.type';

export class HttpRemoteCall {
  /**
   * The base url of the call.
   * @type string
   */
  baseUrl;

  /**
   * The relative path of the call.
   * @type string
   */
  relativePath;

  /**
   * The http method.
   * @type string
   * @see src\services\http\types\http-method.type.js
   */
  method = httpMethod.GET;

  /**
   * A flag that tells if the credentials should be sent over the CORS.
   * @type boolean
   */
  withCredentials = false;

  /**
   * The http response type.
   */
  responseType = httpResponseType.JSON;

  /**
   * Tells if the remote call can be cached or not.
   * @type boolean
   */
  cache = false;

  /**
   * The response parser.
   */
  responseParser;

  constructor(responseParser) {
    this.responseParser = responseParser;
  }

  get fullPath() {
    return `${this.baseUrl}/${this.relativePath}`;
  }

  /**
   * The headers of the request.
   * @type object
   */
  // eslint-disable-next-line class-methods-use-this
  getHeaders() {
    return !this.cache
      ? {
          'Snf-Remote-Call-No-Cache': true
        }
      : {};
  }

  /**
   * The query parameters of the request.
   * @type string
   */
  // eslint-disable-next-line class-methods-use-this
  getQuery() {
    return null;
  }

  /**
   * The body of the request.
   * @type object
   */
  // eslint-disable-next-line class-methods-use-this
  getBody() {
    return null;
  }

  /**
   * Serializes the body. By default it assumes the body type is json,
   * you can customize this behaviour by overrinding the method.
   */
  getSerializedBody() {
    const body = this.getBody();
    return body ? JSON.stringify(body) : null;
  }

  /**
   * Serializes the query params.
   */
  getSerializedQuery() {
    const params = this.getQuery();
    const serializedParams = params ? new URLSearchParams(params).toString() : null;

    return serializedParams;
  }
}
